import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import CphiMilanNetworking from "@/pages/CphiMilanNetworking";

export const Route = createFileRoute("/en/cphi-milan-networking-event")({
  head: () => buildRouteHead("/en/cphi-milan-networking-event"),
  component: CphiMilanNetworking,
});

